import { motion } from "framer-motion";
import { STEPS } from "../data";
import { WhatsAppButton } from "./WhatsAppButton";

export const Process = () => {
  return (
    <section id="ablauf" className="relative scroll-mt-24 overflow-hidden bg-[#060A14] py-24 md:py-32">
      <div className="absolute inset-0 grid-overlay opacity-40" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center"
        >
          <span className="text-sm font-bold uppercase tracking-[0.25em] text-[#3B82F6]">In 3 Schritten</span>
          <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-white md:text-5xl">
            Dein Weg auf die <span className="gradient-text">Straße</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base text-gray-300 md:text-lg">
            Kein Papierkram, kein Stress. So einfach startest du noch diese Woche.
          </p>
        </motion.div>

        <div className="relative grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* connecting line */}
          <div className="absolute left-0 right-0 top-12 hidden h-px bg-gradient-to-r from-transparent via-[#60A5FA]/50 to-transparent md:block" />

          {STEPS.map((s, i) => (
            <motion.div
              key={i}
              data-testid={`step-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="relative z-10 rounded-2xl border border-white/10 bg-[#0B111E] p-8 text-center"
            >
              <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full border border-white/10 bg-gradient-to-br from-[#3B82F6] to-[#60A5FA] font-heading text-2xl font-extrabold text-white shadow-lg shadow-[#60A5FA]/30">
                {s.step}
              </div>
              <h3 className="font-heading text-xl font-bold text-white">{s.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-gray-400">{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <WhatsAppButton size="lg" testid="process-whatsapp" label="Jetzt auf WhatsApp starten" pulse />
        </div>
      </div>
    </section>
  );
};
